// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Demander à Amigo',
    assistant: 'Assistant',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Demander à Amigo, nouveautés : {{count}}',
    amigo_other: 'Demander à Amigo, nouveautés : {{count}}',
    assistant_one: 'Assistant, nouveautés : {{count}}',
    assistant_other: 'Assistant, nouveautés : {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo indisponible',
    assistant: 'Assistant indisponible',
  },
  unavailable_text: {
    amigo: "Amigo n'est pas disponible pour le moment.",
    assistant: "L'assistant n'est pas disponible pour le moment.",
  },
};
